import React from 'react';
import styled from 'styled-components';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const handlePageChange = (page) => {
        if (page !== currentPage) {
            onPageChange(page);
        }
    };

    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

    return (
        <PaginationContainer>
            <Button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
            >
                Prev
            </Button>
            {pages.map(page => (
                <PageButton
                    key={page}
                    isActive={page === currentPage}
                    onClick={() => handlePageChange(page)}
                >
                    {page}
                </PageButton>
            ))}
            <Button
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
            >
                Next
            </Button>
        </PaginationContainer>
    );
};

const PaginationContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 1rem 0;
`;

const Button = styled.button`
    background: none;
    border: none;
    padding: 0.5rem 1rem;
    cursor: pointer;
    color: #007bff;
    font-weight: bold;
    &:disabled {
        color: #ccc;
        cursor: not-allowed;
    }
`;

const PageButton = styled.button`
    background: ${({ isActive }) => (isActive ? '#007bff' : 'none')};
    border: 1px solid #007bff;
    color: ${({ isActive }) => (isActive ? '#fff' : '#007bff')};
    padding: 0.5rem 1rem;
    margin: 0 0.25rem;
    cursor: pointer;
    &:hover {
        background: ${({ isActive }) => (isActive ? '#0056b3' : '#f0f0f0')};
    }
`;

export default Pagination;